import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromLayout from '../layout/layout.reducer';

export interface State {
  layout: fromLayout.LayoutState;
}

export const reducers: ActionReducerMap<State> = {
  layout: fromLayout.layoutReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? []
  : [];
